import { default as Tooltip, TooltipProps as Props } from "antd/lib/tooltip";
import React from "react";
import { createGlobalStyle } from "styled-components";

import { translucentBlack } from "~/Color";
import * as Shadow from "~/Shadow";

export const Component: Component<{
  readonly Content: Component;
  readonly children?: Props["children"];
}> = ({ Content, children }) => (
  <Tooltip
    title={Content}
    destroyTooltipOnHide
    overlayClassName="ant-tooltip-overlay"
  >
    {children}
  </Tooltip>
);

export namespace AntOverride {
  export const Component = createGlobalStyle`
    .ant-tooltip-overlay {
      z-index: 100000;
    }

    .ant-tooltip-inner {
      background: ${translucentBlack(0.87)};
      ${Shadow.Box.styles(Shadow.offThePage())}
    }
  `;
}
